// (() => {
//   const playVideo = (slider) => {
//     if (slider.swiper) {
//       const sliderSwiper = slider.swiper;
      
//       if (sliderSwiper.slides[sliderSwiper.previousIndex]) {
//         const videoPrev = sliderSwiper.slides[
//           sliderSwiper.previousIndex
//         ].querySelector(".slideshow__video video");
//         if (videoPrev) {
//           videoPrev.pause();
//         }
//       }

//       if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
//         const videoActive = sliderSwiper.slides[
//           sliderSwiper.activeIndex
//         ].querySelector(".slideshow__video video");
//         if (videoActive) {
//           videoActive.play();
//         }
//       }
//     }
//   };

//   const stopVideo = (slider) => {
//     if (slider.swiper) {
//       const sliderSwiper = slider.swiper;

//       if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
//         const videoActive = sliderSwiper.slides[
//           sliderSwiper.activeIndex
//         ].querySelector(".slideshow__video video");
//         if (videoActive) {
//           videoActive.pause();
//         }
//       }
//     }
//   };

//   const initSlider = (section) => {
//     if (!section || !section?.classList.contains("section-slideshow")) return;

//     const box = section.querySelector(".slideshow");

//     if (box) {
//       const swiperParams = {
//         speed: 700,
//         autoHeight: false,
//         allowTouchMove: true,
//         watchSlidesProgress: true,
//         preventInteractionOnTransition: true,
//         mousewheel: {
//           forceToAxis: true,
//         },
//       };

//       const changeColorScheme = (swiper) => {
//         const activeIndex = swiper.activeIndex;
//         const activeSlide = swiper.slides[activeIndex];
//         const colorScheme = activeSlide.dataset.colorScheme;

//         const changeItems = [
//           swiper.navigation.nextEl,
//           swiper.navigation.prevEl,
//           swiper.pagination.el
//         ];

//         changeItems.forEach((item) => {
//           if (item) {
//             let classNames = item.getAttribute("class");
//             classNames = classNames.replace(/color-background-\d+/g, "");
//             item.setAttribute("class", classNames);
//             item.classList.add(colorScheme);
//           }
//         });
//       };
      

//       if (box.getAttribute("data-autoplay") === "true") {
//         swiperParams.autoplay = {
//           delay: Number(section.querySelector('.slideshow').dataset.duration),
//           disableOnInteraction: false,
//           pauseOnMouseEnter: box.getAttribute("data-pause-autoplay-hover") === "true",
//         };
//         swiperParams.on = {
//           autoplayTimeLeft(s, time, progress) {
//             if (isNaN(progress)) {
//               return;
//             }

//             const invertedProgress = 1 - progress;
//             const activeBullet = section.querySelector(
//               ".swiper-pagination-bullet-active"
//             );

//             if (activeBullet) {
//               activeBullet.style.setProperty(
//                 "--width-bg",
//                 `${invertedProgress * 100}%`
//               );
//             }
//           }
//         }
//       }

//       if (box.getAttribute("data-loop") === "true") {
//         swiperParams.loop = true;
//         //swiperParams.loopPreventsSliding = false;
//       }

//       if (box.getAttribute("data-pagination") === "true") {
//         const paginationEl = box.querySelector(".swiper-pagination");

//         swiperParams.pagination = {
//           el: paginationEl,
//           type: "bullets",
//           clickable: true,
//         };
//       }

//       if (box.getAttribute("data-navigation") === "true") {
//         const prevBtn = box.querySelector(".slideshow__navigation-button-prev");
//         const nextBtn = box.querySelector(".slideshow__navigation-button-next");

//         swiperParams.navigation = {
//           nextEl: nextBtn,
//           prevEl: prevBtn,
//         };
//       }

//       if (box.getAttribute("data-parallax") === "true") {
//         swiperParams.parallax = true;
//       }

//       if (box.getAttribute("data-animation-type") === "fade") {
//         swiperParams.effect = "fade";
//       } else {
//         swiperParams.effect = "slide";
//       }

//       swiperParams.breakpoints = {
//         990: {
//           spaceBetween: 8,
//         },
//       };
      

//       const sliderOverlay = box.querySelector(".slideshow__swiper--overlay");

//       if (sliderOverlay) {
//         const swiperOverlay = new Swiper(sliderOverlay, swiperParams);

//         changeColorScheme(swiperOverlay);
//         swiperOverlay.on("slideChange", function () {
//           changeColorScheme(swiperOverlay);
//           playVideo(sliderOverlay);

//           if (box.getAttribute("data-autoplay") === "true") {
//             const bullets = section.querySelectorAll('.swiper-pagination-bullet');
//             bullets.forEach((bullet) => {
//               bullet.style.setProperty('--width-bg', '0%'); 
//             });
//           }
//         });

//         if (box.getAttribute("data-pagination") === "true" || box.getAttribute("data-navigation") === "true") {
//           if (sliderOverlay.querySelector('.slideshow__controls-wrapper')) {
//             const widthControls = sliderOverlay.querySelector('.slideshow__controls-wrapper').offsetWidth + 'px';
//             section.querySelector('.slideshow--with-controls').style.setProperty('--width-controls', `${widthControls}`);
//           }
//         }
//       }
      
//     }
//   };

//   const initSection = (section) => {
//     if (!section || !section?.classList.contains("section-slideshow")) return;

//     const slider = section.querySelector(".slideshow__swiper");

//     if (!slider) return;

//     const sectionObserver = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           if (slider) {
//             playVideo(slider);
//           }
//         } else {
//           if (slider) {
//             stopVideo(slider);
//           }
//         }
//       });
//     });

//     sectionObserver.observe(section);

//     initSlider(section);
//   };

//   initSection(document.currentScript.parentElement);

//   document.addEventListener("shopify:section:load", function (event) {
//     initSection(event.target);
//   });
// })();

(() => {
  // ─── Video helpers ────────────────────────────────────────────────────────

  // Helper — try to play a video; swallow the autoplay-policy rejection
  // (e.g. when the user hasn't interacted with the page yet).
  const safePlay = (video) => {
    const p = video.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  };

  // A slide can hold MORE than one .slideshow__video <video> element when both
  // the desktop and mobile variants are configured (CSS hides whichever
  // doesn't match the viewport). Iterate ALL of them so the visible variant
  // gets play()/pause() — querySelector would only ever hit the first one.
  const playVideo = (slider) => {
    if (!slider.swiper) return;
    const { slides, previousIndex, activeIndex } = slider.swiper;

    if (slides[previousIndex]) {
      slides[previousIndex]
        .querySelectorAll(".slideshow__video video")
        .forEach((v) => v.pause());
    }
    if (slides[activeIndex]) {
      slides[activeIndex]
        .querySelectorAll(".slideshow__video video")
        .forEach(safePlay);
    }
  };

  const stopVideo = (slider) => {
    if (!slider.swiper) return;
    const { slides, activeIndex } = slider.swiper;

    if (slides[activeIndex]) {
      slides[activeIndex]
        .querySelectorAll(".slideshow__video video")
        .forEach((v) => v.pause());
    }
  };

  // ─── Controls width helper (called at init AND on resize) ─────────────────

  /**
   * FIX #3 — Extracted into its own function so it can be re-called on resize.
   * Previously this block ran only once inside initSlider(), making
   * `--width-controls` stale after any viewport change.
   */
  const updateControlsWidth = (section, sliderOverlay) => {
    const wrapper = sliderOverlay?.querySelector(".slideshow__controls-wrapper");
    const target  = section?.querySelector(".slideshow--with-controls");
    if (wrapper && target) {
      target.style.setProperty("--width-controls", `${wrapper.offsetWidth}px`);
    }
  };

  // ─── Colour-scheme sync ───────────────────────────────────────────────────

  const changeColorScheme = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    const colorScheme = activeSlide.dataset.colorScheme;

    [swiper.navigation.nextEl, swiper.navigation.prevEl, swiper.pagination.el]
      .forEach((item) => {
        if (!item) return;
        let cls = item.getAttribute("class");
        cls = cls.replace(/color-background-\d+/g, "");
        item.setAttribute("class", cls);
        item.classList.add(colorScheme);
      });
  };

  // ─── Core initialiser ─────────────────────────────────────────────────────

  const initSlider = (section) => {
    if (!section?.classList.contains("section-slideshow")) return;

    const box = section.querySelector(".slideshow");
    if (!box) return;

    const swiperParams = {
      speed: 700,
      autoHeight: false,
      allowTouchMove: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,

      /**
       * FIX #1 — observer + observeParents
       * Swiper v11 does NOT automatically recalculate slide dimensions when
       * the viewport changes unless these flags are set. Without them the
       * slider's internal width stays at whatever it was at mount time,
       * producing misaligned slides on resize / desktop reload.
       */
      observer: true,
      observeParents: true,

      /**
       * FIX #2 — explicit updateOnWindowResize
       * Swiper v11 has a known quirk where this flag's default behaviour can
       * silently skip the internal update cycle when `observer` is absent.
       * Setting it explicitly guarantees the recalc fires.
       */
      updateOnWindowResize: true,

      mousewheel: {
        forceToAxis: true,
      },

      breakpoints: {
        990: {
          spaceBetween: 8,
        },
      },
    };

    // ── Autoplay ─────────────────────────────────────────────────────────────
    if (box.getAttribute("data-autoplay") === "true") {
      swiperParams.autoplay = {
        delay: Number(box.dataset.duration),
        disableOnInteraction: false,
        pauseOnMouseEnter: box.getAttribute("data-pause-autoplay-hover") === "true",
      };
      swiperParams.on = {
        autoplayTimeLeft(s, time, progress) {
          if (isNaN(progress)) return;
          const activeBullet = section.querySelector(".swiper-pagination-bullet-active");
          if (activeBullet) {
            activeBullet.style.setProperty("--width-bg", `${(1 - progress) * 100}%`);
          }
        },
      };
    }

    // ── Loop ─────────────────────────────────────────────────────────────────
    if (box.getAttribute("data-loop") === "true") {
      swiperParams.loop = true;
    }

    // ── Pagination ───────────────────────────────────────────────────────────
    if (box.getAttribute("data-pagination") === "true") {
      swiperParams.pagination = {
        el: box.querySelector(".swiper-pagination"),
        type: "bullets",
        clickable: true,
      };
    }

    // ── Navigation ───────────────────────────────────────────────────────────
    if (box.getAttribute("data-navigation") === "true") {
      swiperParams.navigation = {
        nextEl: box.querySelector(".slideshow__navigation-button-next"),
        prevEl: box.querySelector(".slideshow__navigation-button-prev"),
      };
    }

    // ── Parallax / effect ────────────────────────────────────────────────────
    if (box.getAttribute("data-parallax") === "true") swiperParams.parallax = true;

    swiperParams.effect =
      box.getAttribute("data-animation-type") === "fade" ? "fade" : "slide";

    // ── Mount Swiper ─────────────────────────────────────────────────────────
    const sliderOverlay = box.querySelector(".slideshow__swiper--overlay");
    if (!sliderOverlay) return;

    const swiperOverlay = new Swiper(sliderOverlay, swiperParams);

    // Initial colour-scheme sync
    changeColorScheme(swiperOverlay);

    swiperOverlay.on("slideChange", () => {
      changeColorScheme(swiperOverlay);
      playVideo(sliderOverlay);

      if (box.getAttribute("data-autoplay") === "true") {
        section.querySelectorAll(".swiper-pagination-bullet").forEach((bullet) => {
          bullet.style.setProperty("--width-bg", "0%");
        });
      }
    });

    // Initial controls width
    if (
      box.getAttribute("data-pagination") === "true" ||
      box.getAttribute("data-navigation") === "true"
    ) {
      updateControlsWidth(section, sliderOverlay);
    }

    /**
     * FIX #4 — Debounced resize handler
     * Even with observer+updateOnWindowResize, the controls-width CSS custom
     * property must be recalculated manually because it depends on a DOM
     * measurement (`offsetWidth`), not on Swiper internals.
     *
     * The debounce (150 ms) prevents thrashing during continuous drag-resize
     * while still feeling instant to the user.
     */
    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Swiper's own update (handles slide widths, breakpoints, loop clones)
        swiperOverlay.update();

        // Re-measure controls wrapper after layout has settled
        if (
          box.getAttribute("data-pagination") === "true" ||
          box.getAttribute("data-navigation") === "true"
        ) {
          updateControlsWidth(section, sliderOverlay);
        }
      }, 150);
    };

    window.addEventListener("resize", onResize, { passive: true });

    /**
     * FIX #5 — Shopify section reload cleanup
     * When Shopify re-renders a section in the Theme Editor the old JS
     * context persists, leaving a dangling resize listener attached to
     * `window`. We remove it when the section is unloaded so the GC can
     * collect the old Swiper instance and prevent duplicate handlers after
     * a re-render.
     */
    document.addEventListener(
      "shopify:section:unload",
      (event) => {
        if (event.target.contains(section)) {
          window.removeEventListener("resize", onResize);
          swiperOverlay.destroy(true, true);
        }
      },
      { once: false }
    );

    return swiperOverlay; // expose for debugging / external access if needed
  };

  // ─── Section bootstrap ────────────────────────────────────────────────────

  const initSection = (section) => {
    if (!section?.classList.contains("section-slideshow")) return;

    const slider = section.querySelector(".slideshow__swiper");
    if (!slider) return;

    // Intersection observer — play/pause video as section enters/leaves viewport
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.isIntersecting ? playVideo(slider) : stopVideo(slider);
      });
    });
    sectionObserver.observe(section);

    initSlider(section);
  };

  // ─── Entry points ─────────────────────────────────────────────────────────

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });
})();